import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Briefcase, ChevronDown } from 'lucide-react';

/**
 * RoleSelector — shown in the main app header (top-right area).
 *
 * - 0 roles  → nothing rendered
 * - 1 role   → static badge with role name
 * - 2+ roles → <select> picklist; changing it calls setActiveRole
 */
const RoleSelector = () => {
    const { agentRoles, activeRole, setActiveRole } = useAuth();

    if (!agentRoles || agentRoles.length === 0) return null;

    if (agentRoles.length === 1) {
        return (
            <div
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary text-xs font-medium"
                title={agentRoles[0].description || agentRoles[0].name}
            >
                <Briefcase size={12} />
                <span>{agentRoles[0].name}</span>
            </div>
        );
    }

    return (
        <div className="relative flex items-center">
            <Briefcase size={14} className="absolute left-2.5 text-primary pointer-events-none" />
            <select
                value={activeRole?.id || ''}
                onChange={(e) => {
                    const selected = agentRoles.find(r => r.id === e.target.value) || null;
                    setActiveRole(selected);
                }}
                className="
                    pl-8 pr-7 py-1.5
                    text-xs font-medium
                    bg-primary/10 border border-primary/30 text-primary
                    rounded-full cursor-pointer
                    appearance-none focus:outline-none focus:ring-1 focus:ring-primary/50
                    transition-colors hover:bg-primary/20
                "
                title="Cambiar rol activo"
            >
                {agentRoles.map(role => (
                    <option key={role.id} value={role.id} className="bg-slate-900 text-slate-100">
                        {role.name}
                    </option>
                ))}
            </select>
            <ChevronDown size={12} className="absolute right-2.5 text-primary pointer-events-none" />
        </div>
    );
};

export default RoleSelector;
